import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcademyService {
  private http = inject(HttpClient);
  private readonly baseUrl: string = environment.apiUrl;

  private refreshJobCentersSubject = new BehaviorSubject<boolean>(false);
  refreshJobCenters$ = this.refreshJobCentersSubject.asObservable();

  notifyJobCentersRefresh(notify: boolean) {
    this.refreshJobCentersSubject.next(notify);
  }

  getCourses() {
    return this.http.get<any[]>(`${this.baseUrl}/administrative/academy/`)
  }

  getCourseById(idCourse: string) {
    return this.http.get<any>(`${this.baseUrl}/administrative/academy/${idCourse}`)
  }

  addCourse(data: any) {
    return this.http.post<any[]>(`${this.baseUrl}/administrative/academy/`, data)
  }

  patchCourse(data: any, idCourse: string) {
    return this.http.patch<any[]>(`${this.baseUrl}/administrative/academy/${idCourse}/`, data)
  }

  deleteCourse(idCourse: string) {
    return this.http.delete<any[]>(`${this.baseUrl}/administrative/academy/${idCourse}`)
  }

  getForms(courseId: string) {
    return this.http.get<any[]>(`${this.baseUrl}/administrative/answer/?courses=${courseId}`);
  }

  getFormById(idForm: string) {
    return this.http.get<any>(`${this.baseUrl}/administrative/answer/${idForm}/`);
  }

  addForm(data: any) {
    return this.http.post<any[]>(`${this.baseUrl}/administrative/answer/`, data);
  }

  patchForm(data: any, idForm: string) {
    return this.http.patch<any[]>(`${this.baseUrl}/administrative/answer/${idForm}/`, data);
  }

  deleteForm(idForm: string) {
    return this.http.delete<any[]>(`${this.baseUrl}/administrative/answer/${idForm}`);
  }

  submitFormAnswers(data: any) {
    return this.http.post<any>(`${this.baseUrl}/administrative/response/`, data);
  }
}
